export default "__VITE_ASSET__BYgDimNR__"